import { CommonModule } from '@angular/common';
import { Component, Input, ModuleWithProviders, NgModule, OnInit } from '@angular/core';
import { delay } from 'rxjs/operators';
import { LoadingService } from '../../services/loading.service';

@Component({
  standalone: false,
  selector: 'kig-loading',
  templateUrl: './loading.component.html',
  styleUrls: [ './loading.component.scss' ]
})
export class LoadingComponent implements OnInit {
  @Input() public throttleTime = 500;

  public messages: string[] = [];

  public constructor(private loader: LoadingService) {
  }

  public ngOnInit() {
    this.loader
      .onMessageUpdate()
      .subscribe(message => {
        this.messages.push(message);
      });

    this.loader.onMessageClear()
      .pipe( delay(this.throttleTime))
      .subscribe(message => {
        if (message === LoadingService.clear) {
          this.messages.shift();
        } else if (message === LoadingService.clearAll) {
          this.messages.length = 0;
        } else {
          this.messages.splice(this.messages.indexOf(message), 1);
        }
      });
  }
}

@NgModule({
  declarations: [
    LoadingComponent
  ],
  exports: [
    LoadingComponent
  ],
  imports: [
    CommonModule
  ]
})

export class LoadingModule {
  static forRoot(): ModuleWithProviders<LoadingModule> {
    return {
      ngModule: LoadingModule,
      providers: [
        LoadingService
      ]
    };
  }
}
